{
  "A1": "Novice",
  "A2": "Intermediate Low",
  "B1": "Intermediate Mid",
  "B2": "Intermediate High",
  "C1": "Advanced Low & Mid",
  "C2": "Advanced High & Superior",
  "card_A1": "Novice",
  "card_A2": "Intermediate Low",
  "card_B1": "Intermediate Mid",
  "card_B2": "Intermediate High",
  "card_C1": "Advanced Low & Mid",
  "card_C2": "Advanced High & Superior",
  "edit_discussion": "Edit Discussion",
  "enrolment_key": "Enrollment key",
  "enrolment_key_not_valid": "Enrollment key not valid",
  "enrolment_key_min_chars": "Enrollment key must be at least 5 characters long",
  "limit_access_classroom_visibility_private_including_enrolment_key": "Limit access to your classroom by setting visibility to private and including an enrollment key",
  "enter_private_key": "Enter Enrollment Key",
  "limit_access_course_setting_visibility_private_including_enrolment_key": "Limit access to your course by setting visibility to private and including an enrollment key",
  "change_app_colors": "Change app colors",
  "color": "Color",
  "card_ALL": "All",
  "sort": "Sort",
  "sort_by": "Sort By",
  "skip_navigation": "Skip Navigation",
  "stop_speaking": "Stop Speaking",
  "load_more": "Load More",
  "profiles": "Profiles",
  "view_pdf": "View Story",
  "delete_pdf": "Delete PDF",
  "delete_pdf_confirmation": "Are you sure you want to delete this PDF?",
  "remove_group": "Remove Group",
  "create_groups": "Create Groups",
  "select_all": "Select All",
  "unknown": "Unknown",
  "add_a_discussion_topic": "Add A Discussion Topic",
  "add_a_discussion_prompt": "Add a Discussion Prompt",
  "add_a_url_for_students_to_discuss": "Add a URL for Students to Discuss",
  "images_that_students_can_use_as_a_background_during_the_call": "Images that Students Can Use as a Background During the Call",
  "discussion_images": "Discussion Images",
  "images_for_students_to_discuss_during_the_call": "Images for Students to Discuss During the Call",
  "recording_time": "Recording Time",
  "due_date": "Due Date",
  "record_time_limit": "Record Time Limit",
  "interculturarity": "Interculturality",
  "comprehensibility": "Comprehensibility",
  "function_and_text_type": "Function and Text Type",
  "vocabulary_in_context": "Vocabulary in Context",
  "Drag_and_drop_image_from_your_computer": "Drag and Drop Image from Your Computer",
  "join": "Join",
  "join_date": "Join Date",
  "invited_members": "Invited Students",
  "minute": "Minute",
  "feedback": "Feedback",
  "view": "View",
  "no_data_found": "No Data Found",
  "no_past_discussions_found": "No Past Discussions Found",
  "no_submissions_found": "No Submissions Found",
  "no_scheduled_discussions_found": "No Scheduled Discussions Found",
  "view_more": "View More",
  "past": "Past",
  "submissions": "Submissions",
  "background_images": "Background Images",
  "no_conversation_available": "No Conversation Available",
  "zoom_in": "Zoom In",
  "zoom_out": "Zoom Out",
  "no_special_characters": "Cannot contain special characters",
  "required": "Required",
  "nuala_performance_rating": "Nuala Performance Rating",
  "warning": "Warning",
  "using_nuala_performance": "If you use Nuala Performance Rating, you will lose any manually created grading.",
  "are_you_sure_nuala_performance": "Are you sure you want to use Nuala Performance Rating?",
  "subscription_status_cancelled": "Cancelled",
  "subscription_status_active expired": "Expired",
  "subscription_status_active_expired": "Expired",
  "leaderboard": "Leaderboard",
  "waiting_message": "Get ready, the game will start soon",
  "discussion_topic": "Discussion Topic",
  "discussion_link": "Discussion Link",
  "scheduled": "Scheduled",
  "next_question": "Next question",
  "final_results": "Results",
  "game_ended": "Game ended",
  "discussion_created": "Discussion Created",
  "discussion_updated": "Discussion Updated",
  "give_feedback": "Give Feedback",
  "create_feedback": "Create Feedback",
  "no_discussions_found": "No Discussions Found",
  "no_discussions_found_desc": "All discussions and submissions can be found here",
  "quality_of_interaction": "Quality of Interaction",
  "estimated_game_time": "Estimated Game Time",
  "minutes": "Minutes",
  "discuss": "Discuss",
  "open_live_game": "Open Live Game",
  "game_has_ended": "This game has ended, please wait for a new Live Game.",
  "game_has_canceled": "This game has been canceled, please wait for a new Live Game.",
  "feedback_all_info": "Provides feedback to all students in the discussion group. You cannot provide both group and individual feedback to a student.",
  "rubric_info_desc": "View the Analytic Growth Rubric, the criteria being used in our AI feedback.",
  "go_to": "Go to",
  "exercise_progress_bar": "Exercise progress bar",
  "exercise_no_longer_available": "This exercise is no longer available",
  "rubric_info": "Rubric Info",
  "roleplay_game_in_progress_icon": "Roleplay game currently in progress",
  "roleplay_game_completed_icon": "Roleplay game has been completed {{counter}} time",
  "roleplay_games_completed_icon": "Roleplay game has been completed {{counter}} times",
  "display_classroom_code": "Display classroom code",
  "account": "Account",
  "toggle_light": "Toggle light theme",
  "toggle_dark": "Toggle dark theme",
  "open_search_student_name_filters": "Open search student name filters",
  "remove_card": "Remove Card",
  "archive_title_submissions": "Archive Submissions",
  "archive_description_submissions": "Are you sure you want to archive the submissions?",
  "archive_title": "Archive Discussion",
  "archive_description": "Are you sure you want to archive this discussion? Students invites to this discussion will also be removed.",
  "discussion_templates": "Discussion Templates",
  "discussion_templates_desc": "Use one of our predefined discussion templates, here to help you create content for your students",
  "find_courses": "Find Courses",
  "create_your_own": "Create Your Own ",
  "community_courses_description": "Find a course from the library for your students",
  "create_your_own_description": "Build a brand new course for your students",
  "empty_live_dialog_description": "Add a course if you'd like to play live in the classroom.",
  "resume": "Resume",
  "pause": "Pause",
  "discuss_welcome": "Discuss Guide",
  "discuss_scheduled_discussions": "Scheduled Discussions",
  "discuss_scheduled_discussions_desc": "This is where you will find scheduled discussions created by the teacher. You will be able to join these discussions and talk about a topic with other students in your group.",
  "discuss_refresh_discussions": "Refresh Discussions",
  "discuss_refresh_discussions_desc": "This button will allow you to refresh to get the latest discuss data.",
  "discuss_recorded_discussions": "Record Discussions",
  "discuss_recorded_discussions_desc": "Here you can find discussions you have recorded and submitted for the teacher to review. Once feedback is given you will be able to view it.",
  "discuss_grouped_discussions": "Grouped Discussions",
  "discuss_grouped_discussions_desc": "Here you can find all the discussions you have created for your students based on the topic name. Click into a grouped discussion to see what student groups were created.",
  "discuss_submissions": "Discussion Submissions",
  "discuss_submissions_desc": "Here you can find the recorded discussion submissions created by groups of students. You can view their recording, as well as the transcript of the discussions and give individual or grouped feedback.",
  "refresh_discuss": "Refresh Discuss",
  "teacher": "Teacher",
  "nuala_ai": "Nuala AI",
  "performance_ratings": "Performance Ratings",
  "attended": "Attended",
  "did_not_attend": "Did Not Attend",
  "discussion_attendance": "Discussion Attendance",
  "submitted_recordings": "Submitted Recordings",
  "invalid_date": "Invalid Date",
  "go_to_profile_settings": "Go to profile settings",
  "nudge_add_family_name_title": "Add your last name",
  "go_to_settings": "Go to settings",
  "nudge_add_family_name_profile_desc": "We now support last names. Head to your profile to add yours.",
  "nudge_add_family_name_field_desc": "Enter your last name here so your full name shows across Nualang.",
  "not_applicable": "Omit",
  "comprehension": "Comprehension",
  "feedback_text": "Feedback Text",
  "submit_feedback": "Submit Feedback",
  "select_students_to_group": "Select All Students",
  "created_groups": "Created Groups",
  "feedback_info": "Feedback Info",
  "sample_discussion_ideas": "Sample Discussion Ideas",
  "image_library": "Image Library",
  "interculturality": "Interculturality",
  "upload_video": "Upload Video",
  "select_video_desc": "Drag and drop a video from your computer",
  "add_video": "Add Video",
  "remove": "Remove",
  "play_video": "Play Video",
  "video_info": "Course Video",
  "delete_video": "Delete Video",
  "delete_video_confirmation": "Are you sure you want to delete this video?",
  "view_video": "View Video",
  "video_options": "Video Options",
  "congratulations": "Congratulations!",
  "medal_has_been_added_to_your_profile": "A medal has been added to your profile",
  "disable_keyboard": "Disable Keyboard",
  "enable_keyboard": "Enable Keyboard",
  "save_library": "Save to Library",
  "minimum_two_phrases": "This exercise requires a minimum of two phrases in the topic.",
  "roleplay_not_valid": "This exercise requires a minimum of one interaction and one question.",
  "move_topic": "Move Topic",
  "move_section": "Move Section",
  "move_roleplay": "Move Roleplay",
  "duplicate_roleplay": "Duplicate Roleplay",
  "listen": "Listen",
  "download_template": "Download Template",
  "member_activity": "Student Activity",
  "move_phrase": "Move Phrase",
  "multiple_choice": "Multiple Choice",
  "record": "Record",
  "roleplay-story": "Story",
  "video_included": "Video",
  "story_included": "Story",
  "answer_helper_text": "Press enter / return key to add answer.",
  "move_answer": "Move Answer",
  "remove_answer": "Remove Answer",
  "add_question_desc": "Ask a comprehension question, The question can have multiple correct answers. The order of the answers is how they will appear during the exercise.",
  "update_question_desc": "Ask a comprehension question, The question can have multiple correct answers. The order of the answers is how they will appear during the exercise.",
  "learn_courses_title": "Comprehensive learning paths",
  "exercise_description": "Listen to this phrase",
  "translate_description": "Translate the phrase as quick as you can for the most points!",
  "result_description": "See where you place against everyone else!",
  "listening_description": "Choose an answer as quick as you can for the most points!",
  "roleplay_intro": "Listen to the conversation between the two characters!",
  "generate_question": "Generate Question",
  "generating_question": "Generating Question",
  "experimental_feature_desc_answer": "The 'Generate Question' button is a New AI Feature - We would love to hear your feedback",
  "close_drawer": "Close Drawer",
  "enter_collaborator_email": "Enter a comma or space separated list of email addresses below. Collaborators will be able to make changes to the courses, students and settings of the classroom.",
  "question_type": "Question Type",
  "multiple_choice_factual": "Multiple Choice - Factual",
  "multiple_choice_inference": "Multiple Choice - Inference",
  "vocabulary": "Vocabulary",
  "true_false": "True/False",
  "insert_emoji": "Insert Emoji",
  "moderation_reason": "Image was blocked for containing: {{moderationReason}}",
  "move_bot": "Move Chatbot",
  "duplicate_bot": "Duplicate Chatbot",
  "incomplete_translation": "There is still more to this sentence!",
  "experimental_feature_desc_phrases": "The 'Generate Phrases' button is a New AI Feature - We would love to hear your feedback",
  "choose_topic_for_phrases": "What would you like the phrases to be about?",
  "how_many_phrases": "Number of Phrases: {{phraseAmount}}",
  "generate_phrases": "Generate Phrases",
  "generating_phrases": "Generating Phrases",
  "duplicate_answer_desc": "A question cannot have duplicate answers",
  "question_language": "Choose a language for the questions and answers",
  "generate_questions": "Generate Questions",
  "enable_gen_questions": "Enable this to generate comprehension questions related to the roleplay.",
  "use_topic_phrases": "Use Topic Phrases",
  "enable_phrase_context": "Enable this to use the phrases from your Topic as context in generating the roleplay.",
  "add_phrase_context": "Please add phrases to your topic to enable this feature.",
  "sentences": "Sentences",
  "words": "Words",
  "phrase_type": "Phrase Type",
  "voice_speed": "Voice Speed",
  "download": "Download",
  "phrase_to_speak": "Phrase to Speak",
  "voice_speed_extra_slow": "Extra Slow",
  "voice_speed_slow": "Slow",
  "voice_speed_medium": "Medium",
  "voice_speed_fast": "Fast",
  "voice_speed_extra_fast": "Extra Fast",
  "play_audio": "Play Audio",
  "generate_audio": "Generate Audio",
  "bot_created": "Chatbot Created",
  "bot_deleted": "Chatbot Deleted",
  "move_message": "Move Message",
  "move_question": "Move Question",
  "download_csv_template": "Download CSV Template",
  "upload_csv": "Upload CSV",
  "remove_csv": "Remove CSV",
  "single_phrase": "Single Phrase",
  "list_of_phrases": "List of Phrases",
  "text_studio": "Text-to-Speech Studio",
  "text_studio_description": "The Nualas are here to help you turn text into speech, select a language and choose from our selection of voices to bring your text to life.",
  "no_phrases_yet": "No phrases yet...",
  "access_denied_domain_unverified": "Access Denied: Domain Unverified",
  "file_name": "File Name",
  "download_audio": "Download Audio",
  "no_answer": "No Answer",
  "edit_phrase": "Edit phrase",
  "search_error": "An error occurred while searching, please try again",
  "create_feedback_error": "An error occurred while creating feedback, please try again",
  "get_recs_error": "An error occurred while getting recordings",
  "get_image_error": "An error occurred while getting images",
  "update_discussion_error": "An error occurred while updating discussion, please try again",
  "invite_users_error": "An error occurred inviting users, please try again",
  "delete_picture_confirmation": "Are you sure you want to delete this picture?",
  "create_image_error": "An error occurred while uploading image, please try again",
  "inappropriate_language_detected": "Inapproriate Language Detected",
  "heritage_speaker": "Read/Write",
  "unmark_as_heritage_speaker": "Disable Read/Write Mode",
  "mark_as_heritage_speaker": "Enable Read/Write Mode",
  "heritage_speaker_desc": "Focuses on reading and writing by disabling listening and speaking where appropriate. Designed with heritage learners in mind.",
  "heritage_speaker_point_1": "The word bank will be disabled",
  "heritage_speaker_point_2": "Listening and pronunciation will be disabled where appropriate.",
  "generate_transcript": "Generate Transcript",
  "rewatch_tutorial": "Rewatch Tutorial",
  "auto_generate_phrase_translation": "Generate Translations",
  "word_near_correct": "This word is correct, but it is in the wrong position",
  "partially_correct": "Partially Correct",
  "tag_info": "Tags help organize and categorize content, making it easier to find and group related materials. Use tags to improve the discoverability of your content and streamline your workflow.",
  "archive_discussions": "Archived Discussions",
  "archive_submissions": "Archived submissions",
  "assignment": "Assignment",
  "create_assignment": "Create Assignment",
  "no_assignments": "No Assignments",
  "assignments_description": "Assignments are a great way to engage your students with interactive content. Create assignments to reinforce learning, practice skills, and deepen understanding.",
  "no_assignments_desc": "There are no assignments in this classroom yet.",
  "select_classroom": "Select Classroom",
  "assignment_title": "Assignment Title",
  "assignment_description": "Assignment Description",
  "select_members": "Select Students",
  "schedule_assignment": "Schedule Assignment",
  "assign_date": "Available From",
  "assignments": "Assignments",
  "assign_exercises": "Assign Exercises",
  "assign_exercises_desc": "Select activities from your curated library of content and assign them to your students with just a few clicks. Watch as they engage with exercises designed to reinforce learning, practice skills, and deepen understanding.",
  "add_exercise": "Add Exercise",
  "add_exercises": "Add Exercises",
  "assign_exercises_description": "Select exercises from your library to assign to your students",
  "due_in": "Due in",
  "due_tomorrow": "Due Tomorrow",
  "student_edited_transcript": "Student manually edited this transcript after recording.",
  "classroom_creator_subscription_expired": "The creator's subscription has expired.",
  "return_to_classrooms": "Return to Classrooms",
  "creator_not_subscribed_upgrade_title": "Subscription Expired",
  "creator_not_subscribed_upgrade": "Your subscription has expired. Please upgrade plan in order to continue the following features:",
  "creator_not_subscribed_upgrade_description": "Student access to classroom activities.",
  "creator_not_subscribed_upgrade_description2": "Ability to create Nualang LIVE games",
  "creator_not_subscribed_upgrade_description3": "Student ability to join classroom.",
  "due_today": "Due Today",
  "update_assignment": "Update Assignment",
  "refresh_assignments": "Refresh Assignments",
  "fill_in_the_blanks": "Fill in the blanks",
  "fill_in_the_blanks_description": "Can you correctly identify what's missing?",
  "go_back_to_assignments": "Go back to Assignments",
  "available_today": "Available Today",
  "available_tomorrow": "Available Tomorrow",
  "available_in": "Available in",
  "no_shared_courses": "There are no shared courses between the selected classrooms.",
  "view_submissions": "View Submissions",
  "archive": "Archive",
  "everyone": "Everyone",
  "discussions": "Discussions",
  "duplicate_course_confirmation": "This will make a copy of the course that you can edit. You won't get updates or changes from the original course.",
  "duplication": "Allow others to duplicate this course.",
  "invalid_email_format": "Invalid email format",
  "email_domain_mismatch_error": "Email must be from your domain ({{domain}}).",
  "generic_email_domain_error": "Generic email domain error",
  "duplicate_disabled_tooltip": "This course has been disabled for duplication by the creator.",
  "collaborators_only": "Collaborators",
  "assign_to": "Assign To",
  "all_students": "All Students",
  "default_assignment_title": "New Classroom Assignment",
  "default_assignment_instructions": "Please complete the tasks below before the due date.",
  "due": "Due",
  "hide_course": "Hide Course",
  "show_course": "Show Course",
  "hello": "Hello",
  "dynamic_response": "Dynamic Responses",
  "dynamic_response_desc": "Allow Chatbots in this Classroom to generate customized replies based on student input, powered by AI.",
  "members": "Students",
  "dynamic_responses_info": "Enabling this feature allows the Chatbots to use AI to generate personalized responses based on what students say. While this can support more engaging learning, responses are automatically generated and may vary. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "user_level_settings": "User Level Settings",
  "chatbot_dynamic_responses": "Chatbot - Dynamic Responses",
  "chatbot_dynamic_responses_desc": "If dynamic response is turned on, the Chatbots will actively listen and adapt, prompting for more detail, clearer phrasing, or realistic answers, instead of just moving to the next scripted prompt.",
  "chatbot_now_ai": "Nualang Chatbot: Now with Real-Time Feedback",
  "chatbot_now_ai_desc": "More speaking support. Same structure. No extra work. Students now get helpful, AI-enhanced feedback as they chat!",
  "chatbot_now_ai_revert_settings": "You can limit AI anytime in your ",
  "prefer_original_version": "Prefer the original version?",
  "chatbot_now_ai_benefit": "It’s like giving every student a conversation coach built right into the activity—with zero extra prep or grading.",
  "ai_learn_more": "Want to learn more? Read our approach to AI safety and trust.",
  "ai_settings_desc": "Choose which AI features are available in this classroom.",
  "limit_ai": "AI in this classroom",
  "limit_ai_desc": "Allow the AI features below in this classroom or disable them entirely.",
  "limit_ai_info": "Disabling AI in this classroom turns off each AI feature below at once: Chatbot dynamic responses and AI-generated feedback on Discuss recordings. Teachers can still write and submit their own feedback. All AI use follows clear, trusted standards to ensure safe, responsible, and accountable learning.",
  "limit_ai_course_desc": "Turn chatbot dynamic responses off for this course only. The classroom setting applies unless you change it here.",
  "chatbot_ai": "Chatbot - Dynamic Responses",
  "chatbot_ai_desc": "Allow AI to generate feedback and responses to students or disable to use scripted replies.",
  "discuss_ai": "Discuss - AI feedback",
  "discuss_ai_desc": "Allow AI to generate draft feedback on student submissions or disable to require teacher created feedback only.",
  "ai_allowed": "Enabled",
  "ai_limited": "Disabled",
  "ai_limited_classroom_notice": "AI is disabled in this classroom, the features below are unavailable.",
  "ai_locked_notice": "AI is limited for your whole organization, so it cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_partly_locked_notice": "Some AI features are limited for your whole organization, so they cannot be changed here. Contact your Nualang administrator if this needs to change.",
  "ai_overview_desc": "AI settings for every classroom you teach, including ones you co-teach. Changes apply to the classroom straight away.",
  "ai_overview_empty": "You don't teach any classrooms yet.",
  "ai_overview_load_failed": "Your classrooms could not be loaded. Please try again.",
  "ai_overview_save_failed": "This change could not be saved",
  "ai_overview_apply_all": "Apply to all",
  "ai_overview_enable_all": "Enable for all classrooms",
  "ai_overview_disable_all": "Disable for all classrooms",
  "ai_overview_apply_all_count": "Classrooms that will change",
  "ai_overview_apply_all_skips": "Archived classrooms, and settings fixed by your organization, are not changed.",
  "ai_overview_apply_all_saved": "Classrooms updated",
  "ai_overview_apply_all_failed": "These classrooms could not be updated",
  "ai_overview_course_overrides": "Courses with the chatbot disabled",
  "ai_overview_open_classroom": "Classroom settings",
  "ai_overview_no_active": "All your classrooms are archived.",
  "ai_course_overrides_notice": "Allowed for this classroom, but disabled for these courses",
  "ai_per_course_hint": "You can also limit chatbot dynamic responses for individual courses in Course settings below.",
  "ai_limited_feedback_blocked": "AI is limited for this classroom, so AI feedback cannot be generated.",
  "classroom_settings": "Classroom Settings",
  "student_sent_inappropriate_messages": "The transcript below requires your review.",
  "challenge_mode": "Challenge Mode",
  "student_misuse_reported": "Student Misuse Reported",
  "student_acts_inappropriately": "A student acts inappropriately during a Chatbot exercise",
  "no_members_tooltip": "Cannot perform this action because there are no students or courses in this classroom.",
  "overdue": "Overdue",
  "due_next": "Due Next",
  "active": "Active",
  "archived": "Archived",
  "past_due": "Past Due",
  "available_from": "Available from",
  "roleplay-fill-in-the-blanks": "Scenario fill in the blanks",
  "roleplay-act-it-out": "Scenario act it out",
  "roleplay-act-it-out-listening": "Scenario act it out listening",
  "roleplay-act-it-out-speaking": "Scenario act it out speaking",
  "roleplay-act-it-out-listening-speaking": "Scenario act it out listening and speaking",
  "generate_discussion": "Generate Discussion",
  "generating_discussion": "Generating Discussion",
  "discuss_prompt_language": "Choose a language for the discussion prompt",
  "level": "Level",
  "grouped_discussion": "Grouped Discussion",
  "not_present": "Was not present for the discussion",
  "view_recording": "View Recording",
  "generate_feedback": "Generate Feedback",
  "performance_rating": "Performance Rating",
  "feedback_submitted": "Feedback Submitted",
  "group_not_submitted": "Group has not submitted a recording yet",
  "submission_graded": "Submission Graded",
  "view_submission": "View Submission",
  "show_more": "Show more",
  "show_less": "Show less",
  "course_topic": "Course Topic",
  "discussion_topic_helper": "Select a relevant topic to help generate the discussion.",
  "no_groups_created_yet": "No groups created yet",
  "select_students_from_the_list": "Select students from the list on the left to create a group",
  "drop_members_here": "Drop students here to create a group",
  "drag_a_student_here": "Drag a student here to create a group",
  "new_group": "New Group",
  "cannot_edit_discussion": "Cannot edit discussion with existing submissions",
  "below_level": "Below Level",
  "at_level": "At Level",
  "above_level": "Above Level",
  "ai_performance_assessment": "AI Performance Assessment",
  "performance_chip_tooltip": "Indicates how a student’s performance compares to the expected proficiency range, based on AI analysis.",
  "performance_chip_note": "Visible only to teachers and intended to support instructional review.",
  "you_are_human": "If you are human, leave this field blank",
  "no_scheduled_assignments": "No Scheduled Assignments",
  "no_past_due_assignments": "No Past Due Assignments",
  "no_past_due_discussions": "No Past Due Discussions",
  "no_archived_discussions": "No Archived Discussions",
  "no_discussions": "No Discussions",
  "no_discussions_description": "Discussions are a great way to engage your students with collaborative conversations. Create discussions to practice speaking, build confidence, and develop communication skills.",
  "meaning": "Meaning",
  "meaning_exercise_desc": "Match definitions to the correct phrase.",
  "select_the_correct_phrase": "Select the correct phrase for this definition",
  "phrase_definition": "Phrase Definition",
  "phrase_definition_helper_text": "Press enter / return key to add definition.",
  "phrases_exercise_desc": "Practice key phrases you'll use in conversations.",
  "phrase_group_name": "Phrase List Name",
  "create_phrase_group": "Create Phrase List",
  "preview_phrases": "Preview Phrases",
  "show_keyboard": "Show Keyboard",
  "hide_exercise": "Hide Exercise",
  "phrase_list": "Phrase List",
  "phrase_lists": "Phrase Lists",
  "no_phrase_lists": "No Phrase Lists",
  "all_phrase_lists": "All Phrase Lists",
  "edit_phrase_list": "Edit Phrase List",
  "hide_phrase_list": "Hide Phrase List",
  "move_phrase_list": "Move Phrase List",
  "remove_phrase_list": "Remove Phrase List",
  "show_exercise": "Show Exercise",
  "hide_keyboard": "Hide Keyboard",
  "editor": "Editor",
  "phrase_list_name": "Phrase List Name",
  "phrase_list_information": "Phrase List Information",
  "build_meaning": "Build Meaning",
  "read_and_write": "Read & Write",
  "meaning_listen_and_speak": "Listen & Speak",
  "hide_phrases_exercise": "Hide Phrases",
  "show_phrases_ecercise": "Show Phrases",
  "generate_defintions_error": "There was a problem generating definitions. Please try again.",
  "saving_defintions_error": "There was a problem saving definitions. Please try again.",
  "generate_definitions": "Generate Definitions",
  "generating_definitions": "Generating Definitions",
  "definitions": "Definitions",
  "view_phrase_list": "View Phrase List",
  "meaning_exercise_welcome": "Welcome to the Meaning Exercise",
  "meaning_exercise_definition": "Definition",
  "meaning_exercise_definition_desc": "Select the correct word or phrase based on the definition",
  "meaning_exercise_options": "Options",
  "meaning_exercise_options_desc": "Select the correct options for this sentence",
  "meaning_no_definitions": "This phrase list has no definitions",
  "definition": "Definition",
  "review_generated_definitions": "Review Generated Definitions",
  "new_definitions": "New Definition",
  "current_definitions": "Current Definition",
  "transfer_phrases": "Copy to",
  "transfer": "Copy",
  "create_phrase_list_from_selection": "Create New Phrase List",
  "no_other_phrase_lists": "No other phrase lists",
  "play_phrase_list": "Play Phrase List",
  "read_write_exercise_welcome": "Welcome to the Read & Write Exercise",
  "read_write_exercise_definition": "Definition",
  "read_write_exercise_definition_desc": "Read the definition shown here",
  "read_write_exercise_options": "Type the Phrase",
  "read_write_exercise_options_desc": "Type the correct phrase in the text box",
  "play_phrase": "Play phrase",
  "keyboard": "Keyboard",
  "read_the_definition": "Read the definition",
  "type_the_correct_phrase": "Type the correct phrase",
  "read_write": "Read & Write",
  "meaning_read_write": "Meaning - Read & Write",
  "meaning_read_write_exercise_desc": "Read the definition and type the correct phrase.",
  "image_builder": "Image Builder",
  "background_color": "Background Color",
  "icon": "Icon",
  "pattern_density": "Pattern Density",
  "use_image": "Use Image",
  "background_colour": "Background Colour",
  "icon_opacity": "Icon Opacity",
  "custom_colour": "Custom Colour",
  "live_game_medals": "Live Game Medals",
  "live_game_medals_description": "Unlock medals by placing 1st, 2nd or 3rd during a Live Game",
  "achievements": "Achievements",
  "chatbot": "Chatbot",
  "scenario": "Scenario",
  "conversation": "Conversation",
  "from_course": "From course",
  "from_course_named": "From course: {{title}}",
  "start_topic": "Start topic",
  "start_chat": "Start chat",
  "start_scenario": "Start scenario",
  "n_activities": "{{number}} activities",
  "roleplay_turns": "Roleplay · {{number}} turns",
  "filter_by_type": "Filter by type",
  "view_course_named": "View {{title}}",
  "show": "Show",
  "content_type": "Content type",
  "all_content": "all content",
  "results_summary": "{{number}} results for “{{query}}” · {{types}}",
  "n_results_named": "{{label}}, {{number}} results",
  "app_search_placeholder": "Search community content",
  "view_topic": "View Topic",
  "view_chatbot": "View chatbot",
  "view_scenario": "View scenario"
}
